import { render, staticRenderFns } from "./PsiDetailProfile.vue?vue&type=template&id=19cd62ca"
import script from "./PsiDetailProfile.vue?vue&type=script&lang=js"
export * from "./PsiDetailProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports